<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/maintain/item/page" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item class="noborder" :label="$t('baoyangfenzu')">
						<el-input disabled v-model="$attrs.item.group"></el-input>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/maintain/item/delete')">{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>
		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('baoyangneirong')" required>
						<el-input v-model="yt.editObj.content"></el-input>
					</el-form-item>
					<el-form-item :label="$t('zhuyishixiang')">
						<el-input v-model="yt.editObj.carefully"></el-input>
					</el-form-item>
					<el-form-item :label="$t('beizhu')">
						<el-input v-model="yt.editObj.remark"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini"
						@click="yt.req('POST','/web/maintain/item/create',beforeAdd)" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 编辑表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('baoyangneirong')" required>
						<el-input v-model="yt.editObj.content"></el-input>
					</el-form-item>
					<el-form-item :label="$t('zhuyishixiang')">
						<el-input v-model="yt.editObj.carefully"></el-input>
					</el-form-item>
					<el-form-item :label="$t('beizhu')">
						<el-input v-model="yt.editObj.remark"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini"
						@click="yt.req('POST','/web/maintain/item/update')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	export default {
		name: 'web_mold_management_maintenance_settings_item',
		data() {
			return {
				columns: [{
					label: 'baoyangneirong',
					prop: 'content',
					width: 150
				}, {
					label: 'zhuyishixiang',
					prop: 'carefully',
					width: 150
				}, {
					label: 'beizhu',
					prop: 'remark',
				}, {
					label: 'caozuo',
					type: 'slot',
					width: 180,
					fixed: 'right'
				}]
			};
		},
		created() {
			setTimeout(() => {
				this.yt.conditions = {
					maintainConfigId: this.$attrs.item.id,
				}
				this.yt.get(1);
			}, 300)

		},
		methods: {
			beforeAdd(params, url) {
				params.maintainConfigId = this.$attrs.item.id
				return params
			},
	
		}
	};
</script>
